module.exports = "/_next/static/images/row3-3-2x-02d2b0a1a00ba4c4eb3f8c9b0d01cf28.png";